export const ANON_FORM_TITLE = "Not able to log in? You can still see some order details";
export const ANON_FORM_SUB_TITLE =
  "For security, we can\u2019t show all your order information if you don\u2019t log in to your BT Business order tracker. You could enter your order number to see just the order status \u2013 but you won\u2019t be able to change anything.";
export const AUTH_FORM_TITLE = "Track your order and make updates online";
export const AUTH_FORM_SUB_TITLE =
  "Quickly see how well your order\u2019s progressing. Make sure your contact details are correct. And if you need to get in touch, we\u2019re ready to help. Because you\u2019ve logged in to track your order, you can do much more securely online.";

export const LIVECHAT_TITLE = 'Problem with your order?';
export const LIVECHAT_DESCRIPTION =
  "Please get in touch as soon as you can. We\u2019re here to help Monday - Friday, 09:00 - 17:00.";
